import { useCallback } from 'react';
import { Card } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GenerationToolCardImage } from 'src/components/GenerationToolCardImage';
import { GENERATION_TOOL, GENERATION_TOOL_CARD_NEW_DOCUMENT } from 'src/data/generationTool';

import { useStyles } from './useStyles';

export const CardSmall = ({
  className,
  classes,
  value,
  title,
  description,
  selected,
  onSelect,
  disabled,
  customMultiPromptId,
  customMultiPromptGroup,
  customMultiPromptProjectType,
  wideImage,
  showComingSoonTag,
}) => {
  const styles = useStyles({ classes });

  const handleClick = useCallback(() => {
    const newValue = {
      ...value,
      customMultiPromptId: customMultiPromptId || undefined,
      customMultiPromptGroup: customMultiPromptGroup || undefined,
      customMultiPromptProjectType,
    };
    onSelect(newValue);
  }, [customMultiPromptGroup, customMultiPromptId, customMultiPromptProjectType, onSelect, value]);

  return (
    <Card
      className={cx(styles.root, className, {
        [styles.selected]: selected,
        [styles.disabled]: disabled,
      })}
      onClick={disabled ? null : handleClick}
      data-testid={`templateButton_${value.tool}`}
      square
    >
      {showComingSoonTag && (
        <CustomTypography
          className={styles.comingSoonTag}
          variant={TYPOGRAPHY_VARIANT.medium12}
        >
          Coming soon!
        </CustomTypography>
      )}
      <GenerationToolCardImage
        className={styles.icon}
        tool={value.tool}
        svgStringImage={wideImage}
        projectsPageHeaderIcon
      />
      <div>
        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          <span>{title}</span>
          <span>{description ? ' - ' + description : ''}</span>
        </CustomTypography>
      </div>
    </Card>
  );
};

CardSmall.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  value: PropTypes.shape({
    tool: PropTypes.oneOf(
      Object.values({
        ...GENERATION_TOOL,
        [GENERATION_TOOL_CARD_NEW_DOCUMENT]: GENERATION_TOOL_CARD_NEW_DOCUMENT,
      })
    ).isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  customMultiPromptId: PropTypes.string,
  customMultiPromptGroup: PropTypes.string,
  customMultiPromptProjectType: PropTypes.string,
  wideImage: PropTypes.string,
  showComingSoonTag: PropTypes.bool,
};

CardSmall.defaultProps = {
  className: '',
  classes: {},
  description: '',
  selected: false,
  disabled: false,
  customMultiPromptId: '',
  customMultiPromptGroup: '',
  customMultiPromptProjectType: '',
  wideImage: null,
  showComingSoonTag: false,
};
